/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { enrichedProfileGet } from "../../funcs/enrichedProfileGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetEnrichmentProfileRequest$inboundSchema,
};

export const tool$enrichedProfileGet: ToolDefinition<typeof args> = {
  name: "enriched-profile-get",
  description:
    `Fetch enriched profile data. Requires a valid email address. This service is offered in collaboration with Clearbit. 

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/profile-enrichment.read\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await enrichedProfileGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
